import React, { memo, useEffect, useRef } from "react";
import { formatNumberWithoutComma } from "../../../utility/util";
import { Tooltip } from "antd";
import "../../../MainPage/antdstyle.css";
import { QuestionCircleOutlined } from "@ant-design/icons";

const BasicInput = memo((props) => {
  const {
    required,
    label,
    isStrongLabel,
    value,
    onChange,
    disabled,
    readOnly,
    placeholder,
    id,
    name,
    type = "text",
    format = "text",
    step,
    maxLength,
    minLength,
    isError,
    fullValue,
    styleInput,
    tooltip,
    min,
    max,
    classNameContainer,
    decimalLimit,
    suffix,
    containerStyle,
  } = props;

  const focusRef = useRef(null);

  const handleOnChange = (e) => {
    const val = fullValue ? e : e.target.value;

    if (format === "formatNumberWithoutComma") {
      const formatted = formatNumberWithoutComma(val);
      const regexOnlyDigits = /^[0-9]+$/;

      if (regexOnlyDigits.test(formatted)) {
        onChange(formatted);
      } else {
        onChange("");
      }
    } else if (format === "text") {
      onChange(val);
    } else if (format === "number") {
      const decimalLimitValue = typeof decimalLimit === "number" ? decimalLimit : 2;
      const regex = new RegExp(`^\\d*(\\.\\d{0,${decimalLimitValue}})?$`);

      if (val === "" || regex.test(val)) {
        onChange(val);
      }
    }
  };

  useEffect(() => {
    if (isError) {
      focusRef?.current?.focus();
    }
  }, [isError]);

  return (
    <div className={classNameContainer} style={containerStyle}>
      {label && (
        <label htmlFor={id} onClick={() => focusRef?.current?.focus()}>
          {isStrongLabel ? <strong>{label}</strong> : label}
          {required && <span className="text-danger">* </span>}
          {tooltip && (
            <Tooltip zIndex={9999} placement="right" title={tooltip}>
              <QuestionCircleOutlined style={{ cursor: "pointer" }} />
            </Tooltip>
          )}
        </label>
      )}
      <div className={`input-wrapper ${suffix && "with-suffix"}`}>
        <input
          className="form-control"
          type={type}
          value={value === undefined || value === null ? "" : value}
          required={required}
          disabled={disabled}
          onChange={handleOnChange}
          ref={focusRef}
          placeholder={placeholder}
          name={id | name}
          maxLength={maxLength}
          minLength={minLength}
          min={min}
          max={max}
          style={styleInput}
          readOnly={readOnly}
          step={step}
        />
        {suffix && <span className="input-suffix">{suffix}</span>}
      </div>
      {isError && <div className="text-danger">{isError}</div>}
    </div>
  );
});

BasicInput.displayName = "BasicInput";

export default BasicInput;
